import { Head, useForm } from '@inertiajs/react'
import AdminLayout from '../../../components/layout/AdminLayout'
import Card from '../../../components/ui/Card'
import Button from '../../../components/ui/Button'
import Input from '../../../components/ui/Input'
import Select from '../../../components/ui/Select'
import Checkbox from '../../../components/ui/Checkbox'

/**
 * Admin Users New - Formulaire de création d'utilisateur
 */
export default function AdminUsersNew({ agencies, roles }) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      password_confirmation: '',
      agency_id: '',
      role: 'user',
      admin: false,
      verified: false
    }
  })

  const setField = (field, value) => {
    setData('user', { ...data.user, [field]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/admin/users')
  }

  return (
    <AdminLayout>
      <Head title="Nouvel utilisateur" />

      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Nouvel utilisateur</h1>
          <p className="mt-1 text-sm text-gray-600">
            Créer un nouveau compte utilisateur
          </p>
        </div>

        {/* Formulaire */}
        <Card>
          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email */}
              <div className="md:col-span-2">
                <Input
                  label="Email"
                  type="email"
                  value={data.user.email}
                  onChange={(e) => setField('email', e.target.value)}
                  error={errors['user.email'] || errors.email}
                  required
                  autoFocus
                  placeholder="user@example.com"
                />
              </div>

              {/* Password */}
              <Input
                label="Mot de passe"
                type="password"
                value={data.user.password}
                onChange={(e) => setField('password', e.target.value)}
                error={errors['user.password'] || errors.password}
                required
                placeholder="Minimum 12 caractères"
                helpText="Minimum 12 caractères"
              />

              {/* Password confirmation */}
              <Input
                label="Confirmation mot de passe"
                type="password"
                value={data.user.password_confirmation}
                onChange={(e) => setField('password_confirmation', e.target.value)}
                error={errors['user.password_confirmation'] || errors.password_confirmation}
                required
                placeholder="Répéter le mot de passe"
              />

              {/* Agency */}
              <div className="md:col-span-2">
                <Select
                  label="Agence"
                  name="agency_id"
                  value={data.user.agency_id}
                  onChange={(e) => setField('agency_id', e.target.value)}
                  error={errors['user.agency_id'] || errors.agency_id}
                  required
                  placeholder="Sélectionner une agence..."
                  options={agencies}
                />
              </div>

              {/* Role */}
              <Select
                label="Rôle"
                name="role"
                value={data.user.role}
                onChange={(e) => setField('role', e.target.value)}
                required
                options={roles.map(role => ({
                  value: role,
                  label: role === 'admin' ? 'Administrateur' : 'Utilisateur'
                }))}
              />

              {/* Checkboxes */}
              <div className="md:col-span-2 space-y-4">
                <Checkbox
                  label="Acc&egrave;s administrateur"
                  name="admin"
                  checked={data.user.admin}
                  onChange={(e) => setField('admin', e.target.checked)}
                />

                <Checkbox
                  label="Email v&eacute;rifi&eacute;"
                  name="verified"
                  checked={data.user.verified}
                  onChange={(e) => setField('verified', e.target.checked)}
                />
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end gap-4 pt-6 border-t border-gray-200">
              <Button
                type="button"
                variant="outline"
                onClick={() => window.history.back()}
                disabled={processing}
              >
                Annuler
              </Button>
              <Button
                type="submit"
                variant="primary"
                disabled={processing}
                loading={processing}
              >
                {processing ? 'Création...' : 'Créer l\'utilisateur'}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </AdminLayout>
  )
}
